import {IDto} from "../interface/i.dto";

export abstract class AEntity implements IDto {
  id!: number;
  createdAt!: string;
  updatedAt!: string;

  public constructor(data: Partial<AEntity>) {
    Object.assign(this, data);
  }

}
